var map = {
	"./CanvasClear": 52,
	"./CanvasClear.js": 52,
	"./CanvasMove": 53,
	"./CanvasMove.js": 53,
	"./CommandAbstract": 31,
	"./CommandAbstract.js": 31,
	"./ComponentDelete": 54,
	"./ComponentDelete.js": 54,
	"./ComponentDrag": 55,
	"./ComponentDrag.js": 55,
	"./ComponentEnter": 56,
	"./ComponentEnter.js": 56,
	"./ComponentExit": 57,
	"./ComponentExit.js": 57,
	"./ComponentNext": 58,
	"./ComponentNext.js": 58,
	"./ComponentPrev": 59,
	"./ComponentPrev.js": 59,
	"./ComponentStyleClear": 60,
	"./ComponentStyleClear.js": 60,
	"./CopyComponent": 61,
	"./CopyComponent.js": 61,
	"./DeleteComponent": 62,
	"./DeleteComponent.js": 62,
	"./ExportTemplate": 63,
	"./ExportTemplate.js": 63,
	"./Fullscreen": 64,
	"./Fullscreen.js": 64,
	"./MoveComponent": 65,
	"./MoveComponent.js": 65,
	"./OpenAssets": 66,
	"./OpenAssets.js": 66,
	"./OpenBlocks": 67,
	"./OpenBlocks.js": 67,
	"./OpenLayers": 68,
	"./OpenLayers.js": 68,
	"./OpenStyleManager": 69,
	"./OpenStyleManager.js": 69,
	"./OpenTraitManager": 70,
	"./OpenTraitManager.js": 70,
	"./PasteComponent": 71,
	"./PasteComponent.js": 71,
	"./Preview": 72,
	"./Preview.js": 72,
	"./Resize": 73,
	"./Resize.js": 73,
	"./SelectComponent": 23,
	"./SelectComponent.js": 23,
	"./SelectPosition": 36,
	"./SelectPosition.js": 36,
	"./ShowOffset": 74,
	"./ShowOffset.js": 74,
	"./SwitchVisibility": 75,
	"./SwitchVisibility.js": 75
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;